<template>
    <div class="us_f">
        <div class="left">
            <div class="title">联系我们</div>
            <div class="content" v-for="v in info" :key="v.dictSort">
                <span class="dec">{{ v.dictLabel }} :</span>
                <span class="info">{{ v.dictValue }}</span>
            </div>
        </div>
        <div class="right">
            <MapView />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import MapView from '@/components/mapView.vue'
import { useStore } from '@/store/index';
const store = useStore();

const info = ref([])

onMounted(() => {
    getInfo()
})

const getInfo = async () => {
     const _companyInfo =  store.companyInfo
     info.value = _companyInfo
}
</script>

<style lang="less" scoped>
.us_f {
    width: 100%;
    height: calc(444 * var(--groot-ui-rpx));
    background-image: url('../assets/ad_bg.jpg');
    background-size: cover;

    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    color: #fff;
    text-align: start;
    font-size: calc(16 * var(--groot-ui-rpx));

    .left {
        width: 60%;
        flex: 0.6;
        .content{
            margin-top: calc(28 * var(--groot-ui-rpx));
        }

        .title {
            font-size: calc(30 * var(--groot-ui-rpx));
        }

        .dec {
            display: inline-block;
            margin-right: calc(20 * var(--groot-ui-rpx));
            opacity: 0.8;
            min-width: calc(72 * var(--groot-ui-rpx));
        }
    }

    .right {
        justify-content: center;
        width: 40%;
        height: calc(360 * var(--groot-ui-rpx));
    }
}
</style>